import { Badge } from "@/components/ui/badge";
import { statusClasses } from "@/lib/statusColors";
import { cn } from "@/lib/utils";

export default function StatusBadge({ value, testId }) {
  if (!value) return null;
  return (
    <Badge
      data-testid={testId}
      variant="outline"
      className={cn("font-medium rounded-md px-2 py-0.5 text-xs border", statusClasses(value))}
    >
      {value}
    </Badge>
  );
}
